import moment from "moment";
import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDistributorLogs = createAsyncThunk("fetchDistributorLogs", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		// page: page || 1,
		// limit: limit || 10,
		keyword: filters?.keyword?.trim() || "",
		route_id: filters?.route_id || "",
		// date: moment(filters?.date?.$d).format("YYYY-MM-DD") || "",
	});

	const response = await axiosHttp.get(`distributor/orders/logs?${params}`);
	return response.data;
});

const DistributorLogSlice = createSlice({
	name: "DistributorLogSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		total: 0,
		page: 1,
		limit: 10,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDistributorLogs.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDistributorLogs.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data;
			// state.total = action.payload.pagination?.totalRecords || 0;
			// state.page = action.payload.pagination.currentPage || 1;
		});
		builder.addCase(fetchDistributorLogs.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload.data;
		});
	},
});

export default DistributorLogSlice.reducer;
